export default [
    {
        path: '/finance/receivable',
        name: 'receivable',
        props: true,
        component: () => import('@/views/finance/receivable/index.vue'),
        meta: {
            pageTitle: 'Receivable',
            breadcrumb: [
                {
                text: 'Receivable',
                active: true,
                },
            ],
        },
    },
    {
        path: '/finance/receivable/add',
        name: 'create-receivable',
        component: () => import('@/views/finance/receivable/create.vue'),
        meta: {
            pageTitle: 'Create Receivable',
            breadcrumb: [
                {
                text: 'Receivable',
                to: { name: 'receivable' },
                },
                {
                text: 'Create Receivable',
                active: true,
                },
            ],
        },
    },
    {
        path: '/finance/receivable/:id',
        name: 'detail-receivable',
        props: true,
        component: () => import('@/views/finance/receivable/detail.vue'),
        meta: {
            pageTitle: 'Detail Receivable',
            breadcrumb: [
                {
                text: 'Receivable',
                to: { name: 'receivable' },
                },
                {
                text: 'Detail Receivable',
                active: true,
                },
            ],
        },
    },
]